// @flow

import { userReducer } from './user';
import { session } from './session';
import { minimalPersonnel } from './minimalPersonnel';
import { team } from './team';
import { shift } from './shift';
import { eventGroup } from './eventGroup';
import { error } from './error';
import homebase from './homebase';
import clientSettings from './clientSettings';
import clientConfig from './clientConfig';
import client from './client';
import teamSettings from './teamSettings';
import teamPreferences from './teamPreferences';
import taskProfile from './taskProfile';
import { vehicleReducer } from './vehicle';
import { vehicleModel } from './vehicleModel';
import { bagModel } from './bagModel';
import { vehicleMasterReducer } from './vehicleMaster';
import { riderPersona } from './riderPersona';
import appPreferencesReducer from './appPreferencesReducer';
import toastReducer from './toastReducer';
import locationGeocodeEdit from './locationGeocodeEdit';
import outletLocationGeocodeEdit from './outletLocationGeocodeEdit';
import { location } from './location';
import { lineItem } from './lineItem';
import { outlet } from './outlet';
import { skill } from './skill';
import { zoneMap } from './zoneMap';
import { businessUnits } from './intl';
import { rider } from './rider';
import { transporter } from './transporter';
import { contract } from './contract';
import { pjp } from './pjpMaster';
import { schedulingConfig } from './schedulingConfig';
import { shiftMaster } from './shiftMaster';
import { intelliSort } from './intellisort';
import { salesCategories } from './salesCategories';
import { contactMaster } from './contactMaster';
import { passwordExpiry } from './password';

import uiSwitcher from './uiSwitcher';
import { teamMaster } from './teamMaster';
import { orderMaster } from './orderMaster';
import { TimezoneReducer } from 'common/modules/timezone';
import { personnelMaster } from './personnelMaster';
import { homebaseMaster } from './homebaseMaster';
import { pjpInsights } from './pjpInsights';
import { fpPlanView } from './fpPlanView';
import { territoryPlanning } from './territoryPlanning';
import { territoryMaster } from './territoryMaster';
import { userTour } from './userTour';

// @TODO: fix during code splitting
export type AppState = $FixMe;

const reducers = {
    users: userReducer,
    session,
    minimalPersonnel,
    team,
    shift,
    eventGroup,
    error,
    homebase,
    clientSettings,
    clientConfig,
    client,
    teamSettings,
    teamPreferences,
    taskProfile,
    vehicle: vehicleReducer,
    vehicleMaster: vehicleMasterReducer,
    appPreferences: appPreferencesReducer,
    toast: toastReducer,
    location,
    lineItem,
    outlet,
    vehicleModelMaster: vehicleModel,
    bagModelMaster: bagModel,
    riderPersona,
    skill,
    locationGeocodeEdit,
    outletLocationGeocodeEdit,
    zoneMap,
    businessUnits,
    rider,
    transporter,
    contract,
    pjp,
    schedulingConfig,
    shiftMaster,
    salesCategories,
    contactMaster,
    passwordExpiry,
    teamMaster,
    uiSwitcher,
    intelliSort,
    timezone: TimezoneReducer,
    personnelMaster,
    homebaseMaster,
    orderMaster,
    pjpInsights,
    fpPlanView,
    territoryPlanning,
    territoryMaster,
    userTour
};

export default reducers;
